/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */


import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { IconModule, ScrollToTopComponent } from '@spartacus/storefront';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'cx-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [I18nModule, IconModule],
})
export class CustomScrollToTopComponent extends ScrollToTopComponent {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  private scrollSub!: Subscription;

  ngAfterViewInit() {
    this.scrollSub = fromEvent(document.querySelector('.content-body') as any, 'scroll').subscribe(
      (event) => {
        this.switchDisplay();
      },
    );
  }

  ngOnDestroy() {
    this.scrollSub.unsubscribe();
  }

  /**
   * Scroll back to the top of the page, and recognize if triggerd by keyboard.
   */
  override scrollToTop(event?: MouseEvent): void {
    const el = document.querySelector('.content-body');
    (el as HTMLElement)?.scrollTo({ top: 0, behavior: this.scrollBehavior });
  }

  /**
   * This methods decides when the ScrollToTop button should be displayed.
   */
  protected override switchDisplay(): void {
    const isPastThreshold =
      (document.querySelector('.content-body')?.scrollTop as number) > this.displayThreshold;
    const buttonHasFocus = this.button.nativeElement === document.activeElement;

    if (isPastThreshold || (this.triggedByKeypress && buttonHasFocus)) {
      this.renderer.addClass(this.el.nativeElement, 'display');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'display');
    }
    if (!this.display) {
      this.triggedByKeypress = false;
    }
  }
}
